import { customAxios, customPatchAxios } from "./customAxios";


/**
 * 유지보수>유지관리설비>설비 목록
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisExecutionsEquipmentsByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisExecutions/equipments', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비 등급
 * @param {equipmentId} id 설비ID
 * @returns 
 */
export const getDiagnosisExecutionsEquipmentsLowestGradeById = async(id)=>{
  // const res = await customAxios.get('/api/diagnosisExecutions/equipments/'+id+':lowestGrade');
  const res = await customAxios.get('/api/diagnosisResult/lowestRank/equipment/'+id);
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 설비 별 최근 온도 목록
 * @returns 
 */
export const getLatestTemperatureByEquipmentsByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResult/latestTemperatureByEquipments', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비 구성부 등급
 * @param {equipmentCtrId} levelId 설비분류ID
 * @param {equipmentId} id 설비ID
 * @returns 
 */
export const getDiagnosisExecutionsEquipmentsLowestGradeByLevelIdAndId = async(levelId, id)=>{
  const res = await customAxios.get('/api/diagnosisExecutions/equipments/'+levelId+':lowestGrade?equipment.id='+id);
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * IoT설비 상태
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisExecutionsEquipmentsWithDetailGradeByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisExecutions/equipments:withDetailGrade', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 구성부 목록
 * @param {equipmentId} id 
 * @returns 
 */
export const getEquipmentsCategoriesById = async(id)=>{
  const res = await customAxios.get('/api/equipments/'+id+':equipmentCategories');
  //console.log(res);
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 설비와 연결되어 있는 성공한 최근 진단정보
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisExecutionsByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisExecutions', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 설비와 연결되어 있는 성공한 최근 진단정보
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisExecutionsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/diagnosisExecutions'+query);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 센서의 진단정보 (진단결과, 진단값, 진단일) - 진동센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getResultVibrationRatingsByQuery = async(query)=>{
  const res = await customAxios.get('/api/resultVibrationRatings', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 년도별 진동량 트렌드 그래프 - 진동센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getResultVibrationRatingsSensorsGraphYearByQuery = async(sensorId, query)=>{
  const res = await customAxios.get('/api/resultVibrationRatings/sensors/'+sensorId+':avgByYear', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 날짜별 평균 진동량 트렌드 그래프 - 진동센서인 경우(deprecated)
 * @param {*} query 
 * @returns 
 */
export const getResultVibrationRatingsSensorsGraphDayByQuery = async(sensorId, query)=>{
  const res = await customAxios.get('/api/resultVibrationRatings/sensors/'+sensorId+':avgByDay', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 날짜별 평균 진동량 트렌드 그래프 - 진동센서인 경우(진동량, box)
 * 2026-07-28 dh
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultVibrationSensorsGraphDayByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultVibration:avgByDay', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 날짜검색 평균 진동량 트렌드 그래프 - 진동센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getResultVibrationRatingsSensorsGraphPeriodByQuery = async(sensorId, query)=>{
  const res = await customAxios.get('/api/resultVibrationRatings/sensors/'+sensorId+':avgByPeriod', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 날짜검색 진동량 트렌드 그래프 - 진동센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultVibrationRawPeriodByQuery = async(sensorId, query)=>{
  const res = await customAxios.get('/api/resultVibrationRatings/sensors/'+sensorId+':period', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 날짜별 평균 온도 트렌드 그래프
 * @param {*} query 
 * @returns 
 */
export const getEquipmentTemperatureGraphDayByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentTemperature:avgByDay', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 날짜별 평균 체인 그래프(길이/신율)
 * @param {*} query 
 * @returns 
 */
export const getdDiagnosisResultChainGraphDayByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultChain:avgByDay', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 센서의 진단정보 (진단결과, 진단값, 진단일) - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
// export const getResultVBeltElongsByQuery = async(query)=>{
//   const res = await customAxios.get('/api/resultVBeltElongs', {params : query});
//   //console.log(res);
//   if (res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }

/**
 * 센서의 진단정보 (진단결과, 진단값, 진단일) - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getResultVBeltElongsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/resultVBeltElongs'+ query);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 년도별 신율 트렌드 그래프 - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
// export const getResultVBeltElongsSensorsGraphYearByQuery = async(sensorId, query)=>{
//   const res = await customAxios.get('/api/resultVBeltElongs/sensors/'+sensorId+':avgByYear', {params : query});
//   //console.log(res);
//   if (res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }

/**
 * 날짜별 평균 신율 트렌드 그래프 - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
// export const getResultVBeltElongsSensorsGraphDayByQuery = async(sensorId, query)=>{
//   const res = await customAxios.get('/api/resultVBeltElongs/sensors/'+sensorId+':avgByDay', {params : query});
//   //console.log(res);
//   if (res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }


/**
 * 날짜별 평균 등급이력 그래프 - 소음센서인 경우(deprecated)
 * @param {*} query 
 * @returns 
 */
// export const getResultVBeltElongsSensorsGraphGradeByDayByQuery = async(sensorId, query)=>{
//   const res = await customAxios.get('/api/resultVBeltElongs/sensors/'+sensorId+':avgGradeByDay', {params : query});
//   //console.log(res);
//   if (res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }

/**
 * 날짜별 평균 등급이력 그래프 - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
export const getDiagnosisResultNoiseByDayByQuery = async(query)=>{
  const res = await customAxios.get('/api/diagnosisResultNoise:avgByDay', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 날짜검색 평균 등급이력 그래프 - 소음센서인 경우
 * @param {*} query 
 * @returns 
 */
// export const getResultVBeltElongsSensorsGraphGradeByPeriodByQuery = async(sensorId, query)=>{
//   const res = await customAxios.get('/api/resultVBeltElongs/sensors/'+sensorId+':avgGradeByPeriod', {params : query});
//   //console.log(res);
//   if (res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }


/*****************************************/

/**
 * 경보 전체 목록
 * @returns 
 */
export const getEquipmentAlertsAll = async()=>{
  const res = await customAxios.get('/api/equipmentAlerts');
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 후속조치별 경보건수
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsGroupCountByStatus = async()=>{
  const res = await customAxios.get('/api/equipmentAlerts/:countGroupByFllwActionType');
  //console.log(res);
  if (res) {
     //return Object.values(res.data);
     return res;
  }
  return null;
}


/**
 * 후속조치별 경보건수2
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsGroupCountByFllwActionType = async(query)=>{
  // const res = await customAxios.get('/api/equipmentAlerts/:countGroupByFllwActionType2', {params : query});
  const res = await customAxios.get('/api/equipmentAlerts/countByFllwActionType', {params : query});
  //console.log(res);
  if (res) {
     //return Object.values(res.data);
     return res;
  }
  return null;
}

/**
 * 경보 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsDiagnosisByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts:detail', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 목록(파라미터)(진단정보포함)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertsDiagnosisByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts:detail'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}


/**
 * 대시보드 모니터링 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getDashboardEquipmentAlertsLatestWithStatusDByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts:latestWithStatusD'+query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentAlertsById = async(id)=>{
  const res = await customAxios.get('/api/equipmentAlerts/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 삭제
 * @param {*} param 
 */
export const deleteEquipmentAlerts = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/equipmentAlerts/'+param);
}


/**
 * 경보 유예 등록
 * @param {*} id 
 * @param {*} body 
 */
export const patchEquipmentAlertDelaysRegister = async(id, body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentAlertDelays/equipments/'+id+':register',body);
}

/**
 * 경보 유예 해제
 * @param {*} id 
 * @param {*} body 
 */
export const patchEquipmentAlertDelaysRelease = async(id, body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentAlertDelays/equipments/'+id+':release',body);
}

/**
 * 경보 유예 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertDelaysByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlertDelays',{params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 유예 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentAlertDelaysById = async(id)=>{
  const res = await customAxios.get('/api/equipmentAlertDelays/equipments/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 경보 유예 상태별 건수
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAlertDelaysGroupCountByStatus = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlertDelays/:countGroupByStatus',{params : query});
  //console.log(res);
  if (res) {
    return res;
  }
  return null;
}

/**************************************************************************/

/**
 * 주의관찰 목록
 * @param {*} query 
 * @returns 
 */
export const getAttentionObservationsByQuery = async(query)=>{
  //console.log(query);
  const res = await customAxios.get('/api/attentionObservations',{params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 주의관찰 목록
 * @param {*} query 
 * @returns 
 */
export const getAttentionObservationsByQueryString = async(query)=>{
  //console.log(query);
  const res = await customAxios.get('/api/attentionObservations'+ query);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 주의관찰 상태별 건수
 * @param {*} query 
 * @returns 
 */
export const getAttentionObservationsCountGroupByStatus = async()=>{
  const res = await customAxios.get('/api/attentionObservations/:countGroupByStatus');
  //console.log(res);
  if (res) {
     //return Object.values(res.data);
     return res;
  }
  return null;
}

/**
 * 주의관찰 상세
 * @param {*} id 
 * @returns 
 */
export const getAttentionObservationsById = async(id)=>{
  const res = await customAxios.get('/api/attentionObservations/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 주의관찰 해제
 * @param {*} id 
 * @param {*} body 
 */
export const patchAttentionObservationsRelease = async(id, body)=>{
  //console.log(body);
  const res = await customPatchAxios.patch('/api/attentionObservations/'+id+':release',body);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**************************************************************************/
